//@ts-ignore
import { FormLayout } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import CreateIcon from "../../Icons/CreateIcon";
import { IPostSchema, createPostSchema } from "../../utils/validationSchema";
import CreatePostForm from "./PostForm";

const CreatePost = (props: any) => {
  const { isLoading, handleCreate } = props;

  const {
    register,
    handleSubmit,
    getValues,
    setError,
    setValue,
    clearErrors,
    control,
    formState: { errors },
  } = useForm<IPostSchema>({
    defaultValues: async () => ({
      headline: "",
      content: "",
      author: "",
      category: [] as { label: string; value: string }[],
      tag: [] as { id: string; value: string }[],
      preview_image: null,
      table_of_content: "",
    }),
    resolver: yupResolver(createPostSchema),
  });

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Create Blog
        </span>
      </div>
      <FormLayout
        handleSubmit={handleSubmit}
        handleFormSubmit={handleCreate}
        setError={setError}
        buttonLabel={"Create"}
        isLoading={isLoading}
      >
        <CreatePostForm
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          control={control}
        />
      </FormLayout>
    </div>
  );
};

export default CreatePost;
